export default "/images/4edb60107311838f8e8addddf1137987.avif";